var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-row',{staticClass:"label m-b-h",attrs:{"type":"flex","justify":"start","align":_vm.iconAlign,"gutter":10}},[_c('el-col',{attrs:{"span":-1}},[_vm._t("icon")],2),_c('el-col',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }